import {
  SidebarItem,
  SidebarSubmenu,
  SidebarSubmenuItem,
} from '@backstage/core-components';
import PeopleIcon from '@material-ui/icons/People';
import { UsersIcon } from '../../components/icons';
import { useMyTeams } from './useMyTeams';

const teamsIcon = () => <UsersIcon className="hone-nav-icon" />;

export function YourTeamSidebarItem() {
  const { loading, teams } = useMyTeams();

  if (loading || teams.length === 0) {
    return null;
  }

  if (teams.length === 1) {
    return <SidebarItem icon={teamsIcon} to={teams[0].path} text="Your Team" />;
  }

  return (
    <SidebarItem icon={teamsIcon} text="Your Teams">
      <SidebarSubmenu title="Your Teams">
        {teams.map(team => (
          <SidebarSubmenuItem
            key={team.ref}
            title={team.title}
            to={team.path}
            icon={PeopleIcon}
          />
        ))}
      </SidebarSubmenu>
    </SidebarItem>
  );
}
